// src/pages/OtherPlatformsPage/OtherPlatformsPage.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ObfuscatedStrings } from '../../services/obfyscatedStrings';
import BackgroundCanvasWithoutRadar from '../../widgets/canvas/BackgroundCanvasWithoutRadar';
import { platformIcons } from '../../assets/images/platformIcons';
import Loader from '../../widgets/Loader/Loader';
import './OtherPlatformsPage.scss';

interface PlatformCardProps {
    icon: string;
    platform: string;
    onClick?: () => void;
}

const PlatformCard: React.FC<PlatformCardProps> = ({ icon, platform, onClick }) => {
    return (
        <div className="other-platform-card" onClick={onClick}>
            <img src={icon} className="other-platform-icon" alt={platform} />
            <div className="other-platform-label">Инструкция</div>
            <div className="other-platform-name">для {platform}</div>
        </div>
    );
};

function OtherPlatformsPage() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const tg = (window as any).Telegram?.WebApp;
        if (tg) {
            tg.ready();
            tg.expand();
            tg.setHeaderColor?.('#000000');
            tg.setBackgroundColor?.('#000000');
        }

        // Имитация загрузки или реальная проверка
        const timer = setTimeout(() => {
            setLoading(false);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    const handlePlatformClick = (platform: string, protocol: string = 'wireguard') => {
        const platformMap: Record<string, string> = {
            'Linux': 'linux',
            'Android TV': 'androidtv'
        };

        const path = platformMap[platform];
        if (path) {
            navigate(`/other-instructions/${path}?protocol=${protocol}`);
        }
    };

    if (loading) {
        return (
            <div className="tg-app">
                <BackgroundCanvasWithoutRadar />
                <div className="other-platforms-page loading">
                    <div className="other-loader"><Loader /></div>
                </div>
            </div>
        );
    }

    return (
        <div className="tg-app">
            <BackgroundCanvasWithoutRadar />

            <div className="other-platforms-page">
                {/* Header с кнопкой назад */}
                <div className="other-page-header">
                    <button className="other-back-button" onClick={() => navigate('/install')}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M15 18l-6-6 6-6" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <h1 className="other-page-title">Другие платформы</h1>
                </div>

                {/* Герой блок */}
                <div className="other-hero">
                    <div className="other-hero-icon">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor"/>
                            <path d="M8 21h8" stroke="currentColor" strokeLinecap="round"/>
                            <path d="M12 17v4" stroke="currentColor" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <div className="other-hero-title">Выберите платформу</div>
                    <div className="other-hero-subtitle">Инструкции по установке {ObfuscatedStrings.getCodeConfigurationDefult()} для дополнительных устройств</div>
                </div>

                {/* Список платформ */}
                <div className="other-platforms-list">
                    <PlatformCard
                        icon={platformIcons.linux}
                        platform="Linux"
                        onClick={() => handlePlatformClick('Linux', 'wireguard')}
                    />

                    <PlatformCard
                        icon={platformIcons.android}
                        platform="Android TV"
                        onClick={() => handlePlatformClick('Android TV', 'wireguard')}
                    />
                </div>
            </div>
        </div>
    );
}

export default OtherPlatformsPage;